import React, { Fragment, useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Countdown, { zeroPad } from 'react-countdown';
import axios from 'axios';

import { LiveEvent, NextLiveEvent, NoLiveEvent } from '../components';
import { startLoader } from '../components/common/Loader';

import { userActions } from '../redux/actions';
import { API_URL } from '../redux/services/user.service';
import * as tools from '../utils/tools';

import '../assets/styles/pages/_livePages.scss';
import { SEO } from '../utils';

async function getLiveData () {
  const res = await axios({
    url: `${API_URL}/live`,
  });

  const { data } = await res;
  return data;
}

const LivePage = ({ match, getConcerts, getMeta, ...props }) => {
  const windowWidth = tools.canUseDOM ? window.innerWidth : 1024;
  const windowHeight = tools.canUseDOM ? window.innerHeight : 800;
  const [pageUrl, setPageUrl] = useState('');
  const [concert, setConcert] = useState(null);
  const [concertProgram, setConcertProgram] = useState(null);
  const [customEventData, setCustomEventData] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [liveEvent, setLiveEvent] = useState(null);
  const [nextDate, setNextDate] = useState(0);

  useEffect(() => {
    getMeta('Live events');
    startLoader();
    setPageUrl(window.location.href);
  }, []);

  const metaData = props.metaData?.res;

  const setPageData = ({
    current_event: finalData,
    next_event: upcomingData,
    timezone,
  }) => {
    if (finalData) {
      setVideoUrl(finalData.url);
      if (finalData.concert_id) {
        const liveEvent = {
          currentEvent: finalData,
          nextEvent: { ...upcomingData },
          timezone,
        };
        setConcert(finalData.concert);
        setConcertProgram(finalData.document);
        setLiveEvent(liveEvent);
      } else {
        const customEvent = {
          title: finalData.title,
          desc: finalData.desc,
          url: finalData.url,
          start_date: finalData.start_date,
          end_date: finalData.end_date,
        };
        const liveEvent = {
          currentEvent: finalData,
          nextEvent: { ...upcomingData },
          timezone,
        };
        setVideoUrl(finalData.url);
        setLiveEvent(liveEvent);
        setCustomEventData(customEvent);
      }
    } else {
      const liveEvent = {
        currentEvent: false,
        nextEvent: { ...upcomingData },
        timezone,
      };

      const nextDate = new Date(upcomingData?.start_date).getTime();
      setLiveEvent(liveEvent);
      setVideoUrl(upcomingData?.url);
      setNextDate(nextDate);
    }
  };

  function isEmpty (obj) {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    (async () => {
      const data = await getLiveData();
      data?.current_event?.isExternal
          ?
          window.location.replace(data.current_event.url)
          :
          setPageData(data);
    })();
  }, [match.params.url, match, videoUrl]);

  useLayoutEffect(() => {
    const t = setInterval(async () => {
      const data = await getLiveData();
      if (data?.current_event && data?.current_event?.url) {
            data?.current_event?.isExternal
            ?
            window.location.replace(data.current_event.url)
            :
            setPageData(data);
      } else if (data?.current_event === false && data?.next_event) {
        setPageData(data);
      }
    }, 10000);
    return () => clearInterval(t);
  }, [videoUrl]);

  useEffect(() => {
    document.getElementById('menuLogo').classList.add('showMenuLogo', 'mobile-header-logo');
    document.getElementById('headLine').classList.add('headline');
    document.getElementsByClassName('menu__bar__live__icon')[0].classList.add('live-btn-color');
    return () => {
      document.getElementById('menuLogo').classList.remove('showMenuLogo', 'mobile-header-logo');
      document.getElementsByClassName('menu__bar__live__icon')[0].classList.remove('live-btn-color');
      document.getElementById('headLine').classList.remove('headline');
    };
  }, []);

  return (
    <>
    <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />
    <div
      className={`live_page ${
        liveEvent && liveEvent.currentEvent
          ? 'current__event'
          : liveEvent && !liveEvent.currentEvent && liveEvent.nextEvent
          ? 'next__event'
          : 'no__event'
      }`}
    >
      <Link to='/' className='banner-logo'>
        <img src='/media/images/InClassicaColorLogo.png' alt='logo' />
      </Link>

      {liveEvent && liveEvent.currentEvent ? (
        <LiveEvent
          data={liveEvent.currentEvent}
          videoUrl={videoUrl}
          otherData={{
            windowWidth,
            windowHeight,
            concertProgram,
            concert,
            customEventData,
            pageUrl,
          }}
        />
      ) : liveEvent && !liveEvent.currentEvent && !isEmpty(liveEvent.nextEvent) ? (
        <NextLiveEvent
          data={liveEvent.nextEvent}
          otherData={{
            windowWidth,
            windowHeight,
            concertProgram,
            concert,
            customEventData,
            pageUrl,
            timezone: liveEvent.timezone,
          }}
          // data={liveEvent.nextEvent}
        />
      ) : (
        <NoLiveEvent />
      )}
    </div>
    </>
  );
};

LivePage.propTypes = {
  match: PropTypes.object,
  getConcerts: PropTypes.func,
  getMeta: PropTypes.func,
  metaData: PropTypes.object,
  concerts: PropTypes.array,
};

function mapState (state) {
  return {
    metaData: state.getMeta,
  };
}

const mapDispatchToProps = {
  getMeta: userActions.getMetaData,
  getConcerts: userActions.getConcerts,

};

LivePage.fetchMeta = () => mapDispatchToProps.getMeta('Live events');
LivePage.serverFetch = mapDispatchToProps.getConcerts;

export default connect(mapState, mapDispatchToProps)(LivePage);
